import { onReady } from './utils/on-ready';
import { onWindowResize } from './utils/window-resize';
import { isTouch } from './utils/helpers';
import { initAnchorScroll } from './utils/scroll';
import { setupIntersect } from './utils/intersect';
import { setupVue } from './components/vue';
import { setupNavigation } from './layout/navigation';
import { calculateIframeSize } from './components/iframe-resize';
import { setupSearch } from './components/search';
import { setupCard } from './components/card';
import { setupJobs } from './components/jobs';
import { setupLanguageSelector } from './components/language-selector';
import { setupAccordions } from './components/accordion';
import { setupYoutubeVideos } from './components/youtube-video';
import { setupVimeoVideos } from './components/vimeo-video';
import { setupSwipers } from './components/swiper';
// import { setupThemeSwitcher } from './components/theme-switcher';

let youtubeVideosInitialized = false;

function handleMarketingConsent() {
    // eslint-disable-next-line no-undef
    if (!youtubeVideosInitialized && typeof CookieInformation !== 'undefined' && CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
        youtubeVideosInitialized = true;
        setupYoutubeVideos();
    }
}

function init() {

    setTimeout(() => {
        document.body.classList.remove('standby');
    }, 0);

    if (isTouch) {
        document.body.classList.add('touch-device');
    }

    setupVue();

    onReady(() => {
        calculateIframeSize();
        initAnchorScroll();
        setupIntersect();
        setupNavigation();
        setupSearch();
        setupCard();
        setupJobs();
        setupLanguageSelector();
        setupAccordions();
        setupSwipers();
        setupVimeoVideos();

        // Handle consent immediately if already given
        handleMarketingConsent();

        // Add event listener for future consent events
        window.addEventListener('CookieInformationConsentGiven', handleMarketingConsent, false);

        // Only use this during test-mode c'')
        // setupThemeSwitcher();
    });

    onWindowResize(() => {
        calculateIframeSize();
    });
}

init();
